
/// src/pages/homePage/HomePage.jsx
import React, { useState } from "react";
import Header from "../../components/header/Header";
import HeroBanner from "../../components/HeroBanner/HeroBanner";
import FeaturedProvidersSection from "../../components/featuredProviders/FeaturedProvidersSection";
import RecentlyJoinedSection from "../../components/featuredProviders/RecentlyJoinedSection";
import TestimonialsSection from "../../components/testimonialsSection/TestimonialsSection";
import FAQSection from "../../components/FAQSection/FAQSection";
import Footer from "../../components/footer/Footer";
import BackToTop from "../../components/backToTop/BackToTop";
import useScrollReveal from "../../hooks/useScrollReveal";
import ChallengeBanner from "../../components/challengeBanner/ChallengeBanner";
import ChallengeHeroBanner from "../../components/challengeHeroBanner/ChallengeHeroBanner";
import PopularCategoriesSection from "../../components/popularCategories/PopularCategoriesSection";

// Each section gets its own reveal ref so they animate independently
// as the user scrolls down the page.
const RevealSection = ({ children, id, delay = 0, threshold = 0.12 }) => {
  const { ref, isVisible } = useScrollReveal({ threshold });
  return (
    <section
      id={id}
      ref={ref}
      className={`reveal${isVisible ? " is-visible" : ""}${delay ? ` reveal-delay-${delay}` : ""}`}
    >
      {children}
    </section>
  );
};

function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Hero reveal — lower threshold so it fires almost immediately
  const heroReveal = useScrollReveal({ threshold: 0.05 });

  return (
    <>
      <Header
        user={null}
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        isMenuOpen={isMenuOpen}
      />
      <main className="public-home">
        <ChallengeBanner />

        {/* Hero — fades up as soon as the page loads */}
        <section
          id="home"
          ref={heroReveal.ref}
          // className={`reveal${heroReveal.isVisible ? " is-visible" : ""}`}
        >
          <HeroBanner />
        </section>

        {/* Popular Categories — gives JAMB/WAEC/NECO/Adult Education
            visual prominence and links into the pretty /tutors/... URLs.
            Right after the hero so the primary "find a tutor" path keeps
            momentum, instead of a promo banner breaking it up. */}
        <RevealSection id="popular-categories" threshold={0.1}>
          <PopularCategoriesSection />
        </RevealSection>

        {/* Featured providers — stagger slightly after hero */}
        <RevealSection id="featured-tutors" threshold={0.1}>
          <FeaturedProvidersSection />
        </RevealSection>

        {/* TutorsLinks Educator Impact Challenge 2026 — Abiri Support still
            reachable via the secondary link inside this banner. Moved below
            the core matching sections (categories/featured tutors): the
            challenge is a real initiative worth promoting, but it isn't why
            someone lands on the homepage, so it shouldn't compete with
            "find a tutor" for the first screen. */}
        <RevealSection id="challenge-hero-banner" threshold={0.1}>
          <ChallengeHeroBanner />
        </RevealSection>

        {/* Testimonials */}
        <RevealSection id="testimonials" threshold={0.1}>
          <TestimonialsSection />
        </RevealSection>

        {/* FAQ */}
        <RevealSection id="faq" threshold={0.08}>
          <FAQSection />
        </RevealSection>

        {/* Recently Joined — moved lower on the page; only shows providers
            meeting the minimum profile-completion/quality bar */}
        <RevealSection id="recently-joined" threshold={0.08}>
          <RecentlyJoinedSection />
        </RevealSection>

        {/* Footer — very low threshold, just needs to peek into view */}
        <RevealSection id="footer" threshold={0.05}>
          <Footer />
        </RevealSection>

        <BackToTop />
      </main>
    </>
  );
}

export default HomePage;
